import {DiscordSDK} from '@discord/embedded-app-sdk';
import { clientId } from './consts';

export async function getAuthCode(discordSdk:DiscordSDK){
    const {code} = await discordSdk.commands.authorize({
        client_id: clientId,
        response_type: 'code',
        state: '',
        prompt: 'none',
        scope: ['identify'],
    });
    return code;
}

export function isRunningInDiscord(){
    // check for instance_id, location_id, launch_id in url params
    const params = new URLSearchParams(window.location.search);
    return params.has('instance_id') && params.has('location_id') && params.has('launch_id');
}